// extracted by mini-css-extract-plugin
module.exports = {"card":"InvestmentSummaryGridCard_card__aKHEo","value":"InvestmentSummaryGridCard_value__1ZAln","title":"InvestmentSummaryGridCard_title__1xP3Z"};